"use client";

import { useRef, useState } from "react";
import Image from "next/image";
import dynamic from "next/dynamic";
const ButtonLink = dynamic(() => import("@/Components/ButtonLink"),{ssr: true});
import { toWebp } from "@/utils/common";

const baseUrl = `${process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL}`;

const IndustryTabsGreen: React.FC<any> = ({ CaseCard }) => {
  const allCaseStudies: any = CaseCard;
  const [activeTab, setActiveTab] = useState<string>(
    allCaseStudies[0]?.title || "",
  );
  const contentRefs = useRef<Record<string, HTMLDivElement | null>>({});

  return (
    <div className="flex flex-col lg:flex-row items-center gap-[30px]">
      {/* Right Image */}
      <div className="w-full lg:w-1/2 bg-[linear-gradient(144.37deg,_rgba(255,_255,_255,_0.5)_-1.37%,_rgba(255,_255,_255,_0.2)_104.56%)] hidden lg:block">
        <div className="md:p-6 p-4 bg-[url(/images/slider/Image-bg.webp)] bg-no-repeat bg-cover bg-center">
          {allCaseStudies?.find((c: { title: string }) => c.title === activeTab)
            ?.image?.data?.attributes?.url && (
            <div className="xl:h-[402px] h-[300px] overflow-hidden border border-white/70">
              {allCaseStudies.find((c: any) => c.title === activeTab)?.image
                ?.data?.attributes?.url && (
                <Image
                  src={toWebp(
                    `${baseUrl}${allCaseStudies.find((c: any) => c.title === activeTab)?.image?.data?.attributes?.url}`,
                  )}
                  alt={
                    allCaseStudies.find(
                      (c: { title: string }) => c.title === activeTab,
                    )?.title || "Case Study Image"
                  }
                  width={500}
                  height={300}
                  quality={80}
                  className="transition-all duration-500 scale-[1] hover:scale-[1.1] w-full h-full object-cover"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {/* Left Tabs */}
      <div className="flex flex-col lg:gap-[32px] w-full lg:w-1/2">
        {allCaseStudies?.map((caseStudy: any, index: number) => {
          const isActive = activeTab === caseStudy.title;

          return (
            <div key={caseStudy.id ?? index}>
              <div
                ref={(el) => {
                  contentRefs.current[caseStudy.title] = el;
                }}
                className="overflow-hidden transition-all duration-500 ease-in-out lg:hidden block"
                style={{
                  maxHeight: isActive ? `350px` : "0px",
                  opacity: isActive ? 1 : 0,
                  marginTop: index === 0 ? "0px" : isActive ? "32px" : "0px",
                }}
              >
                <div className="w-full bg-[linear-gradient(144.37deg,_rgba(255,_255,_255,_0.5)_-1.37%,_rgba(255,_255,_255,_0.2)_104.56%)] lg:hidden block">
                  <div className="w-full p-4 bg-[url(/images/slider/Image-bg.webp)] bg-no-repeat bg-cover bg-center">
                    {allCaseStudies?.find(
                      (c: { title: string }) => c.title === activeTab,
                    )?.image?.data?.attributes?.url && (
                      <div className="h-[258px] overflow-hidden border border-white/70">
                        {allCaseStudies.find((c: any) => c.title === activeTab)
                          ?.image?.data?.attributes?.url && (
                          <Image
                            src={toWebp(
                              `${baseUrl}${allCaseStudies.find((c: any) => c.title === activeTab)?.image?.data?.attributes?.url}`,
                            )}
                            alt={
                              allCaseStudies.find(
                                (c: any) => c.title === activeTab,
                              )?.title || "Case Study Image"
                            }
                            width={500}
                            height={300}
                            quality={80}
                            className="border border-white/70 rounded transition-all duration-500 scale-[1] hover:scale-[1.1] w-full h-full object-cover"
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Tab Button */}
              <div
                onClick={() => setActiveTab(caseStudy.title)}
                className={`cursor-pointer text-lg font-semibold border-b-2 lg:pt-0 pt-6 ${
                  isActive
                    ? "text-black border-transparent pb-0"
                    : "text-gray-500 border-border-light pb-6"
                }`}
              >
                <h3
                  className={`text-heading-5 font-bold ${
                    isActive ? "text-primary-text" : "text-gray-500"
                  }`}
                >
                  {caseStudy?.title}
                </h3>
              </div>

              {/* Tab Content with dynamic height transition */}
              <div
                ref={(el) => {
                  contentRefs.current[caseStudy.title] = el;
                }}
                className="overflow-hidden transition-all duration-500 ease-in-out"
                style={{
                  maxHeight: isActive
                    ? `${contentRefs.current[caseStudy.title]?.scrollHeight}px`
                    : "0px",
                  opacity: isActive ? 1 : 0,
                }}
              >
                <div className="text-subtitle-2 font-regular text-secondary-text mt-2 pb-0">
                  {caseStudy?.Description}
                </div>

                {caseStudy?.link?.href && caseStudy?.link?.label && (
                  <ButtonLink
                    href={caseStudy.link.href}
                    label={caseStudy.link.label}
                    className="lg:mt-[18px] mt-4"
                    color="text-blue-500"
                    stroke="stroke-blue-500"
                  />
                )}

                <span
                  className={`relative block h-0.5 mt-6 ${isActive ? "running-gradient" : ""}`}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default IndustryTabsGreen;
